import { Injectable, Inject } from '@angular/core';
import { Subject, Observable, throwError } from 'rxjs';
import { Szme043aRequest, Szme043aResponse, SZME043AService } from 'sg-api';
import { map, timeout, catchError } from 'rxjs/operators';
import { ApiCommonService } from 'cbc-shared-lib';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';

@Injectable({
  providedIn: 'root'
})
export class UsedSzme043aService {
  /** 請求お客さま番号での請求基本情報取得のSubject */
  private _contractorDetail$ = new Subject<Szme043aResponse>();

  /**
   * 請求お客さま番号での請求基本情報取得のobservable提供
   *
   * @readonly
   * @memberof UsedSzme043aService
   */
  get contractorValueChanges(): Observable<Szme043aResponse> {
    return this._contractorDetail$.asObservable();
  }

  /**
   * コンストラクタ
   * @param {SZME043AService} sZME043AService
   * @param {ApiCommonService} apiCommonService
   * @memberof InitialInfoService
   */
  constructor(private sZME043AService: SZME043AService, private apiCommonService: ApiCommonService, @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   *請求お客さま番号での請求基本情報取得API呼び出し
   *
   * @param {*} value
   * @memberof UsedSzme043aService
   */
  searchContractor(value: any, recptFixNo: string,hakkoYmt: string,claimChargeNo: string,cltsskRrkno: string,cdtmnyNo: string,cdtmnyRrkno: string): Observable<Szme043aResponse> {
    // リクエスト情報生成
    let request: Szme043aRequest = {
      recptFixNo: recptFixNo,
      hakkoYmt: hakkoYmt,
      claimChargeNo: claimChargeNo,
      cltsskRrkno: cltsskRrkno,
      cdtmnyNo: cdtmnyNo,
      cdtmnyRrkno: cdtmnyRrkno
    };

    // 検索条件を保存
    return this.sZME043AService.c17RSZME043APost(this.apiCommonService.setRequestCommon(<any>request),'response')
      .pipe(
        map(response => {
          // エラーが設定されていないかチェックする
          this.apiCommonService.checkError(response);
          this._contractorDetail$.next(response.body);
          return response.body;
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SZME043A');
          return throwError(err.message);
        }));
  }
}
